<script lang="ts" setup></script>
<template>
  <v-dialog max-width="500">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn size="48" icon color="info" v-bind="activatorProps">
        <v-icon icon="mdi-help" />
      </v-btn>
    </template>
    <template v-slot:default="{ isActive }">
      <v-card>
        <v-card-text>
          <slot />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn icon @click="isActive.value = false" color="info">
            <v-icon icon="mdi-close" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
